<template>
    <div class="retailer-map__component" :id="mapId()">
    </div>
</template>

<script>
    import { createApp } from 'vue';
    import { Loader } from '@googlemaps/js-api-loader';
    import { MarkerClusterer } from "@googlemaps/markerclusterer";

    export default {

        props : {
            allRetailers: {
                type : Object,
            },
            filteredRetailers: {
                type : Object,
            },
            currentRetailer: {
                type : [Object, null],
            },
        },

        data()
        {
            return {
                bounds : [],
                center : null,
                google : null,
                markers : [],
                infoWindow : null,
                map : null,
                mapOptions : null,
                norwayCenter : {lat: 61.92122020128065, lng: 9.705509948213278},
            }
        },

        created()
        {
            // console.log('created');
            setTimeout(this.initMap, 250);
        },

        watch:
        {
            filteredRetailers()
            {
                // console.log('updated retailers');
                setTimeout(this.initMap, 250);
            },
            currentRetailer()
            {
                // console.log('updated currentRetailer');
                setTimeout(this.initMap, 250);
            }
        },

        methods: {
            mapId()
            {
                return 'js_retailerMap';
            },

            initMap(id)
            {
                const loader = new Loader({
                    // apiKey: "", // TODO set api key
                    apiKey: "AIzaSyATEJjhFj8vQJN9xuWrZZlk8vLrU5vbqQs",
                    version: "weekly",

                    // the required libraries to use new google.maps, new google.maps.marker aso.
                    libraries: [
                        "places",
                        "geometry",
                        "marker",
                        "maps"
                    ]
                });

                loader.loadCallback(e => {
                    if (! e) {
                        const mapContainer = document.getElementById(this.mapId());

                        if (! mapContainer) {
                            return false;
                        }

                        this.google = google;
                        this.setupMapOptions();

                        const map = new google.maps.Map(
                            document.getElementById(this.mapId()),
                            this.mapOptions
                        );

                        this.map = map;

                        this.infoWindow = new google.maps.InfoWindow({
                            content: "",
                            disableAutoPan: true,
                        });

                        this.setupMarkers();
                        this.updateMap();
                    }
                });
            },

            convertPositions(retailer)
            {
                const lng = parseFloat(retailer.position.lng);
                const lat = parseFloat(retailer.position.lat);

                return {lng: lng, lat: lat}
            },

            setupMapObject()
            {
                const map = new google.maps.Map(
                    document.getElementById(this.mapId()),
                    this.mapOptions
                );

                return map;
            },

            updateMap()
            {
                const map = this.setupMapObject();
                this.map = map;

                // set current retailer to maps center
                if (! this.currentRetailer) {
                    map.fitBounds(this.bounds);
                    // console.log('fit bounds');
                } else {
                    // find current marker to sent info window
                    const currentMarker = this.markers.filter((m) => m.position.lat == this.currentRetailer.position.lat);
                    if (typeof currentMarker === 'object' && typeof currentMarker[0] === 'object') {
                        this.showInfoWindow(currentMarker[0], this.currentRetailer);
                    }
                    // map.panTo(panTo); // set custom map center
                    // map.setZoom(zoom); // set custom map zoom
                }

                // add custom cluster icon
                const renderer = {
                    render: function ({ count, position }) {
                        const pinSvgString = '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 63 62" style="enable-background:new 0 0 63 62;" xml:space="preserve"><path class="st0" d="M31.5,7L31.5,7c13.3,0,24,10.7,24,24l0,0c0,13.3-10.7,24-24,24l0,0c-13.3,0-24-10.7-24-24l0,0C7.5,17.7,18.2,7,31.5,7z" fill="#222E49"/><path class="st1" d="M31.5,3.5L31.5,3.5C46.7,3.5,59,15.8,59,31l0,0c0,15.2-12.3,27.5-27.5,27.5l0,0C16.3,58.5,4,46.2,4,31l0,0C4,15.8,16.3,3.5,31.5,3.5z" stroke="#14387F" fill="none" stroke-opacity="0.4" stroke-width="7" /><text font-size="20" y="38" x="@text_x@" fill="white">@text_label@</text></svg>';

                        const pinSvgText = pinSvgString.replace('@text_label@', count)
                            .replace('@text_x@', count>10 ? '20' : '25');

                        const parser = new DOMParser();

                        const pinSvg = parser.parseFromString(pinSvgText, 'image/svg+xml').documentElement;

                        // return new google.maps.Marker({
                        return new google.maps.marker.AdvancedMarkerElement({
                            position,
                            title: count+ ' verksteder ',
                            zIndex: 9999,
                            content: pinSvg
                        });
                        // return new google.maps.marker.AdvancedMarkerElement({
                        //     label: {
                        //         text: count.toString(),
                        //         color: 'white',
                        //         fontSize: '12px'
                        //     },
                        //     position,
                        //     icon:  {
                        //         url : '/resources/images/svg/icon-cluster.svg',
                        //         scaledSize: new google.maps.Size(45, 45),
                        //     },
                        //     title: '',
                        //     // adjust zIndex to be above other markers
                        //     zIndex: Number(google.maps.marker.AdvancedMarkerElement.MAX_ZINDEX) + count,
                        // });
                    }
                };

                new MarkerClusterer({
                    map: map,
                    markers: this.markers,
                    renderer: renderer
                });
            },

            setupMarkers()
            {
                this.bounds = new google.maps.LatLngBounds();

                const markers = new Array();

                this.filteredRetailers.forEach(retailer  => {
                    this.bounds.extend(new google.maps.LatLng(retailer.position.lat, retailer.position.lng));

                    const pin = {
                        background: "#222e49", // Set your desired color here
                        borderColor: "#222e49", // Optional border color
                        glyph: 'GS',
                        glyphColor: "#fff",
                    };

                    const pinGlyph = new google.maps.marker.PinElement(pin);

                    const marker = new google.maps.marker.AdvancedMarkerElement({
                        position : this.convertPositions(retailer),
                        content: pinGlyph.element
                    });

                    // markers can only be keyboard focusable when they have click listeners
                    // open info window when marker is clicked
                    marker.addListener("click", () => {
                        this.$emit('change-retailer', retailer.id, 'map');
                        this.showInfoWindow(marker, retailer);
                    });

                    markers.push(marker);
                });

                this.markers = markers;
            },

            showInfoWindow(marker, retailer)
            {
                this.infoWindow.setContent(retailer.name);
                this.infoWindow.open(this.map, marker);
                this.map.panTo(marker.position); // set new map center
            },

            setupMapOptions()
            {
                const center = this.currentRetailer ?
                        this.convertPositions(this.currentRetailer) :
                        this.norwayCenter;

                this.mapOptions = {
                    zoom: 20,
                    mapTypeControl   : false,
                    streetViewControl: false,
                    fullscreenControl: false,
                    scrollwheel      : false,
                    center: center,
                    mapId : this.mapId(),
                };
            },


        },
    }
</script>